import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { Currency } from '../../shared/models/core/currency';
import { MaterialCategory } from '../../shared/models/sale/material-category.enum';
import { IDetractionType } from '../../shared/models/catalog/detraction-type';
import { IPagedResult } from '../../shared/models/paged-result';
import { serialize } from '../../utility/serialize';
import { IDetractionTypeFilterSet } from '../../shared/models/catalog/detraction-type-filter-set';

export enum DistributionChannel {
  Default,
  Retail,
  Marketplace,
}
export interface ProductCatalogMaterialCodesFilterSet {
  companyCode: string;
  materialCodes: string[];
  channel: DistributionChannel;
}

export interface ProductCatalogIntegrationResult {
  materialCode: string;
  exists: boolean;
  unitPrice?: number;
  currencyCode?: string;
  name?: string;
  vin?: string;
  category: MaterialCategory;
}

export const catalogApi = createApi({
  reducerPath: 'catalogApi',
  baseQuery,
  endpoints: (builder) => ({
    getCurrencies: builder.query<Currency[], boolean | void>({
      query: () => '/api/currencyTypes',
      transformResponse: (response: { results: Currency[] }, _meta, arg) => {
        const allCurrencies = response.results;
        if (arg) {
          return allCurrencies.filter((c) => c.code === 'PEN');
        }
        return allCurrencies;
      },
    }),
    getDetractionTypes: builder.query<IPagedResult<IDetractionType>, IDetractionTypeFilterSet>({
      query: (filterSet) => ({
        url: `/api/detractionTypes?${serialize(filterSet)}`,
        method: 'GET',
      }),
    }),
    validateMaterialCodes: builder.mutation<
      ProductCatalogIntegrationResult[],
      ProductCatalogMaterialCodesFilterSet
    >({
      query: (filterSet) => ({
        url: '/api/product-catalogs',
        method: 'POST',
        body: filterSet,
      }),
    }),
  }),
});

export const {
  useGetCurrenciesQuery,
  useValidateMaterialCodesMutation,
  useGetDetractionTypesQuery,
} = catalogApi;
